var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-book',{attrs:{"value":_vm.value,"multiple":_vm.multiple,"range":_vm.range,"type":"user"},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }